import { BilberryProduct } from 'src/types/bilberry-api-types';
import { VERSION } from 'src/__autogen/env';
import { atom } from 'ximple';

export const upcomingSelectedTourAtom = atom<BilberryProduct | null>({
    persistKey: 'upcomingSelectedTour',
    initialValue: null,
    appVersion: VERSION,
});
